"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.anamnesticAlcoholAbuseMessages = exports.currentAlcoholAbuseMessages = exports.currentAlcoholUseMessages = exports.AnamnesticAlcoholAbuse = exports.CurrentAlcoholAbuse = exports.CurrentAlcoholUse = void 0;
const schema_1 = require("../../../../../schema");
var CurrentAlcoholUse;
(function (CurrentAlcoholUse) {
    CurrentAlcoholUse["NO_CONSUMPTION"] = "NO CONSUMPTION";
    CurrentAlcoholUse["OCCASIONALLY"] = "OCCASIONALLY";
    CurrentAlcoholUse["REGULARLY"] = "REGULARLY";
})(CurrentAlcoholUse || (exports.CurrentAlcoholUse = CurrentAlcoholUse = {}));
var CurrentAlcoholAbuse;
(function (CurrentAlcoholAbuse) {
    CurrentAlcoholAbuse["YES"] = "YES";
    CurrentAlcoholAbuse["NO"] = "NO";
})(CurrentAlcoholAbuse || (exports.CurrentAlcoholAbuse = CurrentAlcoholAbuse = {}));
var AnamnesticAlcoholAbuse;
(function (AnamnesticAlcoholAbuse) {
    AnamnesticAlcoholAbuse["YES"] = "YES";
    AnamnesticAlcoholAbuse["NO"] = "NO";
})(AnamnesticAlcoholAbuse || (exports.AnamnesticAlcoholAbuse = AnamnesticAlcoholAbuse = {}));
exports.currentAlcoholUseMessages = {
    [CurrentAlcoholUse.NO_CONSUMPTION]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.alcohol.currentAlcoholUse.NO_CONSUMPTION",
        defaultMessage: "Nem fogyaszt"
    },
    [CurrentAlcoholUse.OCCASIONALLY]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.alcohol.currentAlcoholUse.OCCASIONALLY",
        defaultMessage: "Alkalmanként"
    },
    [CurrentAlcoholUse.REGULARLY]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.alcohol.currentAlcoholUse.REGULARLY",
        defaultMessage: "Rendszeresen"
    }
};
exports.currentAlcoholAbuseMessages = {
    [CurrentAlcoholAbuse.YES]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.alcohol.currentAlcoholAbuse.YES",
        defaultMessage: "Igen"
    },
    [CurrentAlcoholAbuse.NO]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.alcohol.currentAlcoholAbuse.NO",
        defaultMessage: "Nem"
    }
};
exports.anamnesticAlcoholAbuseMessages = {
    [AnamnesticAlcoholAbuse.YES]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.alcohol.anamnesticAlcoholAbuse.YES",
        defaultMessage: "Igen"
    },
    [AnamnesticAlcoholAbuse.NO]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.alcohol.anamnesticAlcoholAbuse.NO",
        defaultMessage: "Nem"
    }
};
const currentAlcoholUse = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(CurrentAlcoholUse.NO_CONSUMPTION),
    schema_1.Schema.singleChoiceItem(CurrentAlcoholUse.OCCASIONALLY),
    schema_1.Schema.singleChoiceItem(CurrentAlcoholUse.REGULARLY)
]);
const currentAlcoholAbuse = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(CurrentAlcoholAbuse.YES),
    schema_1.Schema.singleChoiceItem(CurrentAlcoholAbuse.NO)
]).optional();
const anamnesticAlcoholAbuse = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AnamnesticAlcoholAbuse.YES),
    schema_1.Schema.singleChoiceItem(AnamnesticAlcoholAbuse.NO)
]).optional();
const commentOfAlcoholUse = schema_1.Schema.string().optional().maxLength(10000);
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({
    currentAlcoholUse,
    currentAlcoholAbuse,
    anamnesticAlcoholAbuse,
    commentOfAlcoholUse
})
    .interpretation({ vocab: "ktx", code: "alcohol_statement" })
    .tag({ vocab: "fyrms", code: "action" });
